import { render } from "./InsightsResources.vue?vue&type=template&id=a87c3b08&scoped=true"
import script from "./InsightsResources.vue?vue&type=script&lang=js"
export * from "./InsightsResources.vue?vue&type=script&lang=js"

import "./InsightsResources.vue?vue&type=style&index=0&id=a87c3b08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87c3b08"]])

export default __exports__